module.exports = __webpack_public_path__ + "img/sentenance_logo_WH.5bb46099.png";